import React from 'react';
import cn from 'classnames';
import _isArray from 'lodash/isArray';
import _toNumber from 'lodash/toNumber';
import styles from './index.module.scss';

export default function Grid({
  gap = 0,
  templateColumns = '',
  templateRows = 'auto',
  className = '',
  children = null,
  style = {},
  ...divElementProps
}) {
  const count = _isArray(children) ? children.filter(Boolean).length : 1;

  const gridColumns = templateColumns
    ? templateColumns
    : Array.from({ length: count }, () => '1fr').join(' ');

  return (
    <div
      {...divElementProps}
      className={cn(styles.container, className)}
      style={{
        gridTemplateRows: templateRows,
        gridTemplateColumns: gridColumns,
        gap: _toNumber(gap) ? `${gap}px` : gap,
        ...style
      }}
    >
      {children}
    </div>
  );
}
